import { Component, effect, inject, viewChild } from '@angular/core';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../content.error';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { ServiceSettingsSchedulerStore } from './service-settings-scheduler.store';
import { Divider } from '@openng/optimus-ui/divider';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-scheduler',
    templateUrl: 'service-settings-scheduler.component.html',
    providers: [ServiceSettingsSchedulerStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        CheckInputComponent,
        Tooltip,
        TranslatePipe,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsSchedulerComponent {

    public readonly store = inject(ServiceSettingsSchedulerStore);

    protected readonly serviceSettingsCommonComponent = viewChild(ServiceSettingsCommonComponent);

    protected form = fb.group({
        useProcedureTime: fb.control<boolean>(false),
    });

    constructor() {
        effect(() => {
            const defaultValues = this.store.settings();
            if (defaultValues) {
                this.form.patchValue({
                    useProcedureTime: defaultValues?.useProcedureTime ?? this.form.value.useProcedureTime,
                });
                this.serviceSettingsCommonComponent()?.form.patchValue(defaultValues);
            }
        });
    }

    public async save(): Promise<void> {
        const data = {
            ...this.store.settings(),
            useCard: Boolean(this.serviceSettingsCommonComponent()!.form.value.useCard),
            useProcedureTime: Boolean(this.form.value.useProcedureTime),
        };

        await this.store.api.updateServiceSettings({
            key: this.store.settingsKey,
            data: JSON.stringify(data),
            serviceId: Number(routeParams.serviceId()),
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

}
